import React from "react";
import autoBind from "react-autobind";

import BreadCrumbItem from "@common/components/breadcrumb/breadcrumbItem.component";

import breadcrumbSelector from "@common/store/breadcrumb/breadcrumb.selectors";
import breadcrumbActions from "@common/store/breadcrumb/breadcrumb.actions";

import { connect } from "@common/components/base.component";
class BreadCrumbComponent extends React.Component {
  constructor(props) {
    super(props);

    this.props.breadcrumbActions.setCurrentBreadcrumb("default");
    autoBind(this);
  }

  render() {
    const { currentBreadcrumb } = this.props.breadcrumbSelector;

    return currentBreadcrumb && currentBreadcrumb.length > 0 ? (
      <ul className="custom-breadcrumb">
        {currentBreadcrumb.map((item, index) => (
          <BreadCrumbItem item={item} key={index} active={currentBreadcrumb.length - 1 == index} />
        ))}
      </ul>
    ) : null;
  }
}

export default connect({
  selectors: {
    breadcrumbSelector
  },
  actions: {
    breadcrumbActions
  }
})(BreadCrumbComponent);
